import {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

function Row(props) {
    var item = props.item
    var eventSelect = props.eventSelect
    var eventDelete = props.eventDelete

    return(
        <TableRow>
            <TableCell>{item.tipo}</TableCell>
            <TableCell>{item.protocolo}</TableCell>
            <TableCell>{item.puerto}</TableCell>
            <TableCell>{item.velocidad}</TableCell>
            <TableCell>{item.archivo}</TableCell>
            <TableCell>{item.debug}</TableCell>
            <TableCell>{item.estado}</TableCell>
            <TableCell>
                <Button variant="contained" size='small' fullWidth onClick={() => {eventSelect(item)}}>Seleccionar</Button>
                <Button variant="contained" size='small' color="error" fullWidth onClick={() => {eventDelete(item)}}>Borrar</Button>
            </TableCell>
        </TableRow>
    )
}


class TabBilleteros extends Component {
    constructor(props) {
        super(props)

        var tipoDispositivo = props.tipoDispositivo
        var dispositivos = props.dispositivos
        this.guardarEvent = props.event

        this.state = {
            tipoDispositivo: tipoDispositivo,
            dispositivos: dispositivos,
            itemEdicion: null,
            cmbTiposBilletero: 0,
            cmbProtocolos: 0,
            cmbVelocidades: 0,
            cmbEscrows: 0,
            cmbDebugs: 0,
            txtPuerto: "",
            txtArchivo: "",
            txtDenominaciones: "",
            cmbEstados: 0,
            // Tipos de aceptador de billetes. Los soportados por MoneyManager_v2
            // (DeviceFactory) van seleccionables; los del catalogo dispositivos.pdf
            // que aun no tienen driver en v2 van con soportado:false (deshabilitados).
            // 'valor' es lo que se guarda y termina como device en el OPEN del v2:
            // en minusculas debe matchear la fabrica, por eso se conservan las claves
            // Spectra/Ivizion/Mei/CA10 (tambien compatibles con datos ya guardados).
            // 'archivo' es el .db de config del equipo. Al elegir Tipo se autocompletan
            // Protocolo, Velocidad y Archivo (quedan fijos / no editables, ver render):
            // cada equipo define su protocolo y baudios, no los elige el usuario.
            tiposBilletero: [
                { nombre: "BNF/NV200",      valor: "spectral",  archivo: "Spectral.db",  protocolo: "SSP",    velocidad: "9600", soportado: true },
                { nombre: "NV10 USB",       valor: "nv10",      archivo: "nv10.db",      protocolo: "SSP",    velocidad: "9600", soportado: true },
                { nombre: "BV30",           valor: "bv30",      archivo: "bv30.db",      protocolo: "SSP",    velocidad: "9600", soportado: true },
                { nombre: "Ivizion",        valor: "Ivizion",   archivo: "Ivizion.db",   protocolo: "ID003",  velocidad: "9600", soportado: true },
                { nombre: "Mei",            valor: "Mei",       archivo: "Mei.db",       protocolo: "ccTalk", velocidad: "9600", soportado: true },
                { nombre: "CA10",           valor: "CA10",      archivo: "CA-10.db",     protocolo: "SIO",    velocidad: "9600", soportado: true },
                { nombre: "SNBC S110M",     valor: "s110m",     archivo: "S110M.db",     protocolo: "USB",    velocidad: "9600", soportado: true },
                { nombre: "NV9USB+ST",      valor: "NV9USB+ST", archivo: "NV9USBST.db",  protocolo: "SSP",    velocidad: "9600", soportado: false }
            ],
            // Protocolos de comunicacion de aceptadores de billetes (dispositivos.pdf)
            protocolos: [
                "SSP",
                "ccTalk",
                "ID003",
                "MDB",
                "SIO",
                "USB"
            ],
            velocidades: [
                "9600",
                "19200",
                "115200"
            ],
            escrows: [
                "Activado",
                "Desactivado"
            ],
            debugs: [
                "1",
                "2",
                "3",
                "4"
            ],
            estados: [
				{nombre: "Activo", valor: "A"},
				{nombre: "Inactivo", valor: "I"}
			],
            modoEdicion: false
        }
    }

    componentWillUnmount() {

    }

    onChangecmbTiposBilletero = (event) => {
        const tipo = event.target.value
        // Al elegir el Tipo se autocompletan Protocolo, Velocidad y Archivo (.db)
        // segun el equipo. Estos tres quedan fijos / no editables (cada equipo define
        // su protocolo y baudios), ver render.
        const seleccionado = this.state.tiposBilletero.find(item => item.valor === tipo)
        this.setState({
            cmbTiposBilletero: tipo,
            cmbProtocolos: seleccionado ? seleccionado.protocolo : this.state.cmbProtocolos,
            cmbVelocidades: seleccionado ? seleccionado.velocidad : this.state.cmbVelocidades,
            txtArchivo: seleccionado ? seleccionado.archivo : this.state.txtArchivo,
            // Al elegir cualquier tipo se autocompletan las denominaciones COP estandar.
            txtDenominaciones: seleccionado ? "1000_COP,2000_COP,5000_COP,10000_COP,20000_COP,50000_COP,100000_COP" : this.state.txtDenominaciones
        })
    }

    // Placeholder del campo Puerto segun el tipo (sugerencia, NO autocompleta el valor).
    puertoPlaceholder = () => {
        switch (this.state.cmbTiposBilletero) {
            case "spectral": return "/dev/ttyS0"                                              // BNF/NV200 (serial)
            case "nv10":     return "/dev/serial/by-path/pci-0000:00:14.0-usb-0:1:1.0"        // NV10 USB (by-path)
            case "CA10":     return "192.168.1.12"                                            // CA10 (TCP/IP)
            case "s110m":    return "USB (no requiere puerto)"                                // SNBC S110M (USB/libusb, auto)
            default:         return ""
        }
    }

    onChangecmbProtocolos = (event) => {
        const protocolo = event.target.value
        this.setState({cmbProtocolos: protocolo})
    }

    onChangecmbEscrows = (event) => {
        const escrow = event.target.value
        this.setState({cmbEscrows: escrow})
    }

    onChangecmbDebugs = (event) => {
        const debug = event.target.value
        this.setState({cmbDebugs: debug})
    }

    onChangetxtPuerto = (event) => {
        const puerto = event.target.value.toString()
        this.setState({txtPuerto: puerto})
    }

    onChangecmbVelocidades = (event) => {
        const velocidad = event.target.value
        this.setState({cmbVelocidades: velocidad})
    }

    onChangetxtArchivo = (event) => {
        const archivo = event.target.value.toString()
        this.setState({txtArchivo: archivo})
    }

    onChangetxtDenominaciones = (event) => {
        const denominaciones = event.target.value.toString()
        this.setState({txtDenominaciones: denominaciones})
    }
    
    onChangecmbEstados = (event) => {
        const estado = event.target.value
        this.setState({cmbEstados: estado})
    }

    btnSeleccionarClick = (item) => {
        

        this.setState({
            itemEdicion: item,
            cmbTiposBilletero: item.tipo,
            cmbProtocolos: item.protocolo,
            txtPuerto: item.puerto,
            cmbVelocidades: item.velocidad,
            cmbEscrows: item.escrow,
            cmbDebugs: item.debug,
            txtArchivo: item.archivo,
            txtDenominaciones: item.denominaciones,
            cmbEstados: item.estado,
            modoEdicion: true
        })
    }

    btnBorrarClick = (item) => {
        
        if(window.confirm("¿Borrar dispositivo?")) {
            this.pepararNuevo()
            var dispositivos = this.state.dispositivos

            var x = dispositivos.indexOf(item)
            if(x >= 0) dispositivos.splice(x, 1)


            this.setState({
                dispositivos: dispositivos
            })

            this.guardarEvent(this.state.tipoDispositivo, this.state.dispositivos, this.confirmacionGuardado)
        }

    }

    // Todos los campos son OBLIGATORIOS para agregar/guardar/modificar. Un combo sin
    // elegir vale 0 (numero) y un texto vacio vale "" -> ambos se rechazan.
    camposValidos = () => {
        // El S110M (USB/libusb) NO usa puerto: el SDK auto-conecta por VID:PID. Se exime el
        // campo Puerto de la validacion solo para ese tipo.
        const esUsb = this.state.cmbTiposBilletero === "s110m"
        const campos = [
            this.state.cmbTiposBilletero,
            this.state.cmbProtocolos,
            ...(esUsb ? [] : [this.state.txtPuerto]),
            this.state.cmbVelocidades,
            this.state.cmbEscrows,
            this.state.cmbDebugs,
            this.state.txtArchivo,
            this.state.txtDenominaciones,
            this.state.cmbEstados
        ]
        const vacio = campos.some(v => v === undefined || v === null || v === 0 || (typeof v === 'string' && v.trim() === ""))
        if (vacio) {
            window.alert("Todos los campos son obligatorios para guardar.")
            return false
        }
        return true
    }

    btnGuardarClick = () => {
        if (!this.camposValidos()) return

        var dispositivos = this.state.dispositivos

        var item = {
            tipo: this.state.cmbTiposBilletero,
            protocolo: this.state.cmbProtocolos,
            // S110M: si el puerto va vacio se guarda "usb" (el driver lo ignora y auto-conecta por USB).
            puerto: ( this.state.cmbTiposBilletero === "s110m" && this.state.txtPuerto.trim() === "" ) ? "usb" : this.state.txtPuerto,
            velocidad: this.state.cmbVelocidades,
            escrow: this.state.cmbEscrows,
            debug: this.state.cmbDebugs,
            archivo: this.state.txtArchivo,
            denominaciones: this.state.txtDenominaciones,
            estado: this.state.cmbEstados
        }

        if(this.state.modoEdicion) {
            var x = dispositivos.indexOf(this.state.itemEdicion)
            if(x >= 0) dispositivos[x] = item
        } else {
            dispositivos.push(item)
        }

        this.setState({
            dispositivos: dispositivos
        })

        this.guardarEvent(this.state.tipoDispositivo, this.state.dispositivos, this.confirmacionGuardado)
    }

    pepararNuevo = () => {
        this.setState({
            itemEdicion: null,
            cmbTiposBilletero: 0,
            cmbProtocolos: 0,
            txtPuerto: "",
            cmbVelocidades: 0,
            cmbEscrows: 0,
            cmbDebugs: 0,
            txtArchivo: "",
            txtDenominaciones: "",
            cmbEstados: 0,
            modoEdicion: false
        })
    }

    confirmacionGuardado = () => {
        this.pepararNuevo()
    }

    render() {
        const columns = [
            {field: 'Tipo', headerName: 'Tipo', width: 100},
            {field: 'Protocolo', headerName: 'Protocolo', width: 100},
            {field: 'Puerto', headerName: 'Puerto', width: 100},
            {field: 'Velocidad', headerName: 'Velocidad', width: 50},
            {field: 'Archivo', headerName: 'Archivo', width: 100},
            {field: 'Debug', headerName: 'Debug', width: 50},
            {field: 'Estado', headerName: 'Estado', width: 50},
            {field: '', headerName: '', width: 50}
          ]

        return(
            <Box>
                <Grid container xs={12}>
                    <Grid item xs={12}>
                        <Card fullWidth>
                            <CardContent>
                            	<h3>Billeteros</h3>
                                <form>
                                    <FormLabel>Información billetero</FormLabel>
                                    <br />
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Tipo</InputLabel>
                                            <Select
                                                label="Tipo"
                                                value={this.state.cmbTiposBilletero}
                                                defaultValue={0}
                                                onChange={this.onChangecmbTiposBilletero}>
                                                <MenuItem value={0}>-- Seleccione Tipo --</MenuItem>
                                                {this.state.tiposBilletero.map(item => (
                                                <MenuItem key={item.nombre} value={item.valor} disabled={!item.soportado}>
                                                    {item.soportado ? item.nombre : item.nombre + " (no disponible en v2)"}
                                                </MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Protocolo</InputLabel>
                                            <Select
                                                label="Protocolo"
                                                value={this.state.cmbProtocolos}
                                                defaultValue={0}
                                                disabled
                                                onChange={this.onChangecmbProtocolos}>
                                                <MenuItem value={0}>-- Seleccione Protocolo --</MenuItem>
                                                {this.state.protocolos.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <TextField
                                            label="Puerto"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={this.state.txtPuerto}
                                            placeholder={this.puertoPlaceholder()}
                                            onChange={this.onChangetxtPuerto}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Velocidad</InputLabel>
                                            <Select
                                                label="Velocidad"
                                                value={this.state.cmbVelocidades}
                                                defaultValue={0}
                                                disabled
                                                onChange={this.onChangecmbVelocidades}>
                                                <MenuItem value={0}>-- Seleccione Velocidad --</MenuItem>
                                                {this.state.velocidades.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Escrow</InputLabel>
                                            <Select
                                                label="Escrow"
                                                value={this.state.cmbEscrows}
                                                defaultValue={0}
                                                onChange={this.onChangecmbEscrows}>
                                                <MenuItem value={0}>-- Seleccione Escrow --</MenuItem>
                                                {this.state.escrows.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Debug</InputLabel>
                                            <Select
                                                label="Debug"
                                                value={this.state.cmbDebugs}
                                                defaultValue={0}
                                                onChange={this.onChangecmbDebugs}>
                                                <MenuItem value={0}>-- Seleccione Debug --</MenuItem>
                                                {this.state.debugs.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <TextField
                                            label="Archivo"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={this.state.txtArchivo}
                                            placeholder="Se autocompleta al elegir Tipo (ej. Spectra.db)"
                                            onChange={this.onChangetxtArchivo}
                                            InputLabelProps={{ shrink: true }}
                                            disabled
                                            fullWidth
                                            />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Estado</InputLabel>
                                            <Select
                                                label="Estado"
                                                value={this.state.cmbEstados}
                                                defaultValue={0}
                                                onChange={this.onChangecmbEstados}>
                                                <MenuItem value={0}>-- Seleccione estado --</MenuItem>
                                                {this.state.estados.map(item => (
                                                <MenuItem value={item.valor}>{item.nombre}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth component="fieldset">
                                            <TextField
                                            label="Denominaciones (Billetes)"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={this.state.txtDenominaciones}
                                            placeholder="1000_COP,2000_COP,5000_COP,10000_COP,20000_COP,50000_COP,100000_COP"
                                            multiline
                                            minRows={3}
                                            maxRows={10}
                                            onChange={this.onChangetxtDenominaciones}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </form>
                            </CardContent>
                            <CardActions>
                                <Button  variant="contained" onClick={this.btnGuardarClick}>{ this.state.modoEdicion  === true ? "Modificar": "Agregar"}</Button>
                                <Button  variant="contained" onClick={this.pepararNuevo}>Cancelar</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
                <br />
                <Card xs={8}>
                    <CardContent xs={8}>
                        <TableContainer xs={8}>
                            <Table stickyHeader class="table-data" xs={8}>
                                <TableHead>
                                    <TableRow>
                                        {
                                            columns.map((column) => {
                                                return(
                                                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                </TableHead>
                                {
                                    this.state.dispositivos.map((dispositivo) => {
                                        return(<Row item = {dispositivo} eventSelect={this.btnSeleccionarClick} eventDelete={this.btnBorrarClick} />)
                                    })
                                }
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            </Box>
        )
    }
}

export default TabBilleteros